module.exports = require('./helpers/bundle-url').getBundleURL('13ph5') + "moncraft.f7a273ff.webp";